import { AuthContext } from '@context-providers/auth-context-provider'
import { Brand } from '@context-providers/theme-context-provider'
import { RootDocument } from '@pages/root-document'
import appCss from '@styles/styles.css?url'
import { createRootRouteWithContext } from '@tanstack/react-router'

import { z } from 'zod'

type RouterContext = {
  auth: AuthContext
  brand: Brand
}

const zSharedStateParams = z.object({
  redirectUrl: z.string().optional(),
})

export type AppSearchParams = z.infer<typeof zSharedStateParams>

const getFaviconPath = (brand: Brand, size: string) => {
  switch (brand) {
    case 'haniel':
      return `/favicon-${size}-${brand}.png`
    default:
      return `/favicon-${size}.png`
  }
}

/**
 * all routes are rendered with auth context
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  head: ({ match }) => {
    const { brand } = match.context
    return {
      meta: [
        {
          charSet: 'utf-8',
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1',
        },
        {
          name: 'robots',
          content: 'noindex, nofollow',
        },
        {
          title: 'SteerEx',
        },
        {
          name: 'description',
          content: 'SteerEx',
        },
      ],
      links: [
        {
          rel: 'stylesheet',
          href: appCss,
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '16x16',
          href: getFaviconPath(brand, '16x16'),
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '32x32',
          href: getFaviconPath(brand, '32x32'),
        },
        {
          rel: 'apple-touch-icon',
          type: 'image/png',
          sizes: '180x180',
          href: '/apple-touch-icon.png',
        },
        {
          rel: 'manifest',
          href: '/site.webmanifest',
        },
      ],
    }
  },
  shellComponent: RootDocument,
  validateSearch: zSharedStateParams,
})
